import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Optional Sentry init — strictly no-op when no DSN is configured.
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
if (SENTRY_DSN) {
    // eslint-disable-next-line global-require
    const Sentry = require("@sentry/react");
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: process.env.REACT_APP_ENV || "production",
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.1,
    });
    // Expose for trackers / error boundary
    window.__sentry = Sentry;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>,
);
